/*
  Finder steps + focus (Chris, 22 Oct 2026). Runs on finders shown as photo cards
  (snippets/finder-photo-card.liquid), i.e. the home page stack.

  1. Steps: each drop-down's label gets a numbered badge, joined to the next by a line that fills
     in as the shopper completes the step (done = teal tick, current = navy ring). Steps added
     later (the bimini "Choose your configuration", the US boat cover "Select your exact boat")
     are numbered too.
  2. Focus: once a finder is in use, the finders not in use fade back so the stack isn't
     overwhelming. Hovering one brings it back; using it makes it active too, so several can be
     active at once. A finder whose drop-downs are all cleared again stops being active.

  Works on the finders' own markup; nothing here changes what they do.
*/
(function () {
  if (window.__finderSteps) return; // each photo-card finder includes this script
  window.__finderSteps = true;
  var ROOTS = ".bcf, .bcf--us, .bmf, .ocf, .jsf";
  var FIELD = ".bcf__field, .bmf__field, .ocf__field, .jsf__field";
  var LABEL = ".bcf__label, .bmf__label, .ocf__label, .jsf__label";
  var LATER = ".bcf__tiles-prompt, .bmf__configs > .bmf__label";

  function finders() {
    return Array.prototype.filter.call(document.querySelectorAll(ROOTS), function (r) {
      return r.querySelector(".fpc") && !r.parentElement.closest(ROOTS);
    });
  }

  // ---- steps ----
  function badge(n) {
    var b = document.createElement("span");
    b.className = "fstep__n";
    b.setAttribute("aria-hidden", "true");
    b.innerHTML = '<span class="fstep__num">' + n + '</span><svg class="fstep__tick" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12.5l4.5 4.5L19 7.5"/></svg>';
    return b;
  }
  // Strip the "1. " the label text starts with; the badge carries the number.
  function stripNumber(label) {
    for (var i = 0; i < label.childNodes.length; i++) {
      var t = label.childNodes[i];
      if (t.nodeType === 3 && /\S/.test(t.nodeValue)) { t.nodeValue = t.nodeValue.replace(/^\s*\d+\.\s*/, ""); break; }
    }
  }
  // A drop-down step: badge on its own row above the label, joined to the next by a line.
  function numberField(field, label, n) {
    var b = field.querySelector(":scope > .fstep__n");
    if (b) { b.querySelector(".fstep__num").textContent = n; return; }
    stripNumber(label);
    field.insertBefore(badge(n), field.firstChild);
  }
  // A later step (configuration pills, exact-boat tiles): badge inline before its heading.
  function numberLabel(label, n) {
    var b = label.querySelector(".fstep__n");
    if (b) { b.querySelector(".fstep__num").textContent = n; return; }
    stripNumber(label);
    label.classList.add("fstep");
    label.insertBefore(badge(n), label.firstChild);
  }
  function steps(root) {
    var fields = Array.prototype.filter.call(root.querySelectorAll(".fpc " + FIELD), function (f) {
      return f.querySelector("select") && f.querySelector(LABEL);
    });
    var later = Array.prototype.filter.call(root.querySelectorAll(LATER), function (l) {
      if (!l.closest("[hidden]")) return true;
      l.classList.remove("is-done", "is-current"); // hidden again (selection cleared)
      return false;
    });
    var n = 0, current = false;
    fields.forEach(function (f, i) {
      n++;
      numberField(f, f.querySelector(LABEL), n);
      var sel = f.querySelector("select");
      var done = !!sel.value;
      f.classList.add("fstep-field");
      f.classList.toggle("is-done", done);
      f.classList.toggle("is-current", !done && !current && !sel.disabled);
      if (!done && !sel.disabled) current = true;
      f.classList.toggle("is-last", i === fields.length - 1);
    });
    later.forEach(function (l) {
      n++;
      numberLabel(l, n);
      var host = l.closest(".bmf__configs, [data-role='tiles-step']");
      var chosen = host && host.querySelector("[aria-pressed='true'], .is-selected, .is-chosen");
      l.classList.toggle("is-done", !!chosen);
      l.classList.toggle("is-current", !chosen && !current);
      if (!chosen) current = true;
    });
  }

  // ---- focus ----
  var active = [];
  function inUse(root) {
    return Array.prototype.some.call(root.querySelectorAll("select"), function (s) { return !!s.value; });
  }
  function refresh() {
    var all = finders();
    all.forEach(register);
    active = active.filter(function (r) { return inUse(r) || r.contains(document.activeElement); });
    all.forEach(function (r) {
      steps(r);
      var on = active.indexOf(r) !== -1;
      r.classList.toggle("is-finder-active", on);
      r.classList.toggle("is-finder-dimmed", active.length > 0 && !on);
    });
  }
  function activate(root) {
    if (active.indexOf(root) === -1) active.push(root);
  }

  var queued = false;
  function soon() {
    if (queued) return;
    queued = true;
    setTimeout(function () { queued = false; refresh(); }, 60);
  }

  function register(root) {
    if (root.dataset.fsteps) return;
    root.dataset.fsteps = "1";
    root.classList.add("has-fsteps");
    root.addEventListener("change", function () { activate(root); soon(); });
    root.addEventListener("focusin", function (e) { if (e.target.matches("select, input, button")) { activate(root); soon(); } });
    root.addEventListener("click", function () { soon(); setTimeout(refresh, 400); });
    // steps that appear later (configuration pills, exact-boat tiles)
    new MutationObserver(soon).observe(root, { childList: true, subtree: true, attributes: true, attributeFilter: ["hidden", "aria-pressed", "class", "disabled"] });
  }

  function init() {
    finders().forEach(register);
    document.addEventListener("focusout", soon);
    // theme editor: a section re-rendered after a setting change is a new element
    document.addEventListener("shopify:section:load", function () { finders().forEach(register); refresh(); });
    refresh();
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init);
  else init();
})();
